/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { ControlesAnalyseEtComite } from "../model"
// @ts-ignore
import type { InfoEncadrementRemboursementPretFAI } from "../model"
// @ts-ignore
import type { RessourcesPassees } from "../model"
// @ts-ignore
import type { RessourcesPasseesRequest } from "../model"
/**
 * ControleResourceApi - axios parameter creator
 */
export const ControleResourceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Récupération des contrôles et informations concernant l\'onglet analyse et éligibilité au comité.
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllControlesOk: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("getAllControlesOk", "noteId", noteId)
      const localVarPath = `/v1.0/controle/{noteId}/allControls`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Récupération des contrôles et informations concernant l\'onglet analyse et éligibilité au comité.
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getControles: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("getControles", "noteId", noteId)
      const localVarPath = `/v1.0/controle/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Récupère le total du KRD des prêts locaux de la structure (notifié, en attente de confirmation en suivi, ctx), ainsi que les opérations FAI positionnées sur la note.
     * @param {number} projectId
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInfoEncadrementRemboursementPretFAI: async (
      projectId: number,
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("getInfoEncadrementRemboursementPretFAI", "projectId", projectId)
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("getInfoEncadrementRemboursementPretFAI", "noteId", noteId)
      const localVarPath =
        `/v1.0/controle/{projectId}/structure-ivt-locaux/note/{noteId}/produit-fai-positionnes`
          .replace("{projectId}", encodeURIComponent(String(projectId)))
          .replace("{noteId}", encodeURIComponent(String(noteId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Sauvegarde les ressources passées d\'une note
     * @param {string} noteId
     * @param {RessourcesPasseesRequest} ressourcesPasseesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOrSave: async (
      noteId: string,
      ressourcesPasseesRequest: RessourcesPasseesRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("updateOrSave", "noteId", noteId)
      // verify required parameter 'ressourcesPasseesRequest' is not null or undefined
      assertParamExists("updateOrSave", "ressourcesPasseesRequest", ressourcesPasseesRequest)
      const localVarPath = `/v1.0/controle/ressourcesPassees/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        ressourcesPasseesRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * ControleResourceApi - functional programming interface
 */
export const ControleResourceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ControleResourceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Récupération des contrôles et informations concernant l\'onglet analyse et éligibilité au comité.
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAllControlesOk(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAllControlesOk(noteId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ControleResourceApi.getAllControlesOk"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Récupération des contrôles et informations concernant l\'onglet analyse et éligibilité au comité.
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getControles(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ControlesAnalyseEtComite>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getControles(noteId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ControleResourceApi.getControles"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Récupère le total du KRD des prêts locaux de la structure (notifié, en attente de confirmation en suivi, ctx), ainsi que les opérations FAI positionnées sur la note.
     * @param {number} projectId
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInfoEncadrementRemboursementPretFAI(
      projectId: number,
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InfoEncadrementRemboursementPretFAI>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getInfoEncadrementRemboursementPretFAI(
          projectId,
          noteId,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ControleResourceApi.getInfoEncadrementRemboursementPretFAI"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Sauvegarde les ressources passées d\'une note
     * @param {string} noteId
     * @param {RessourcesPasseesRequest} ressourcesPasseesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateOrSave(
      noteId: string,
      ressourcesPasseesRequest: RessourcesPasseesRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RessourcesPassees>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrSave(
        noteId,
        ressourcesPasseesRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["ControleResourceApi.updateOrSave"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * ControleResourceApi - factory interface
 */
export const ControleResourceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ControleResourceApiFp(configuration)
  return {
    /**
     *
     * @summary Récupération des contrôles et informations concernant l\'onglet analyse et éligibilité au comité.
     * @param {ControleResourceApiGetAllControlesOkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllControlesOk(
      requestParameters: ControleResourceApiGetAllControlesOkRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<boolean> {
      return localVarFp
        .getAllControlesOk(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Récupération des contrôles et informations concernant l\'onglet analyse et éligibilité au comité.
     * @param {ControleResourceApiGetControlesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getControles(
      requestParameters: ControleResourceApiGetControlesRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ControlesAnalyseEtComite> {
      return localVarFp
        .getControles(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Récupère le total du KRD des prêts locaux de la structure (notifié, en attente de confirmation en suivi, ctx), ainsi que les opérations FAI positionnées sur la note.
     * @param {ControleResourceApiGetInfoEncadrementRemboursementPretFAIRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInfoEncadrementRemboursementPretFAI(
      requestParameters: ControleResourceApiGetInfoEncadrementRemboursementPretFAIRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InfoEncadrementRemboursementPretFAI> {
      return localVarFp
        .getInfoEncadrementRemboursementPretFAI(
          requestParameters.projectId,
          requestParameters.noteId,
          options
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Sauvegarde les ressources passées d\'une note
     * @param {ControleResourceApiUpdateOrSaveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateOrSave(
      requestParameters: ControleResourceApiUpdateOrSaveRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RessourcesPassees> {
      return localVarFp
        .updateOrSave(requestParameters.noteId, requestParameters.ressourcesPasseesRequest, options)
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for getAllControlesOk operation in ControleResourceApi.
 */
export interface ControleResourceApiGetAllControlesOkRequest {
  readonly noteId: string
}

/**
 * Request parameters for getControles operation in ControleResourceApi.
 */
export interface ControleResourceApiGetControlesRequest {
  readonly noteId: string
}

/**
 * Request parameters for getInfoEncadrementRemboursementPretFAI operation in ControleResourceApi.
 */
export interface ControleResourceApiGetInfoEncadrementRemboursementPretFAIRequest {
  readonly projectId: number

  readonly noteId: string
}

/**
 * Request parameters for updateOrSave operation in ControleResourceApi.
 */
export interface ControleResourceApiUpdateOrSaveRequest {
  readonly noteId: string

  readonly ressourcesPasseesRequest: RessourcesPasseesRequest
}

/**
 * ControleResourceApi - object-oriented interface
 */
export class ControleResourceApi extends BaseAPI {
  /**
   *
   * @summary Récupération des contrôles et informations concernant l\'onglet analyse et éligibilité au comité.
   * @param {ControleResourceApiGetAllControlesOkRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getAllControlesOk(
    requestParameters: ControleResourceApiGetAllControlesOkRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ControleResourceApiFp(this.configuration)
      .getAllControlesOk(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Récupération des contrôles et informations concernant l\'onglet analyse et éligibilité au comité.
   * @param {ControleResourceApiGetControlesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getControles(
    requestParameters: ControleResourceApiGetControlesRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ControleResourceApiFp(this.configuration)
      .getControles(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Récupère le total du KRD des prêts locaux de la structure (notifié, en attente de confirmation en suivi, ctx), ainsi que les opérations FAI positionnées sur la note.
   * @param {ControleResourceApiGetInfoEncadrementRemboursementPretFAIRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getInfoEncadrementRemboursementPretFAI(
    requestParameters: ControleResourceApiGetInfoEncadrementRemboursementPretFAIRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ControleResourceApiFp(this.configuration)
      .getInfoEncadrementRemboursementPretFAI(
        requestParameters.projectId,
        requestParameters.noteId,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Sauvegarde les ressources passées d\'une note
   * @param {ControleResourceApiUpdateOrSaveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateOrSave(
    requestParameters: ControleResourceApiUpdateOrSaveRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ControleResourceApiFp(this.configuration)
      .updateOrSave(requestParameters.noteId, requestParameters.ressourcesPasseesRequest, options)
      .then(request => request(this.axios, this.basePath))
  }
}
